export enum ERequestDemandActionTypes {
  OPEN_DEMAND_REQUEST_MODAL = 'OPEN_DEMAND_REQUEST_MODAL',
  CLOSE_DEMAND_REQUEST_MODAL = 'CLOSE_DEMAND_REQUEST_MODAL',
  OPEN_DEMAND_SUCCESS_MODAL = 'OPEN_DEMAND_SUCCESS_MODAL',
  CLOSE_DEMAND_SUCCESS_MODAL = 'CLOSE_DEMAND_SUCCESS_MODAL',
  OPEN_DEMAND_SMS_VERIFICATION_MODAL = 'OPEN_DEMAND_SMS_VERIFICATION_MODAL',
  CLOSE_DEMAND_SMS_VERIFICATION_MODAL = 'CLOSE_DEMAND_SMS_VERIFICATION_MODAL',
  DEMAND_REQUEST_SEND_START = 'DEMAND_REQUEST_SEND_START',
  DEMAND_REQUEST_SEND_SUCCESS = 'DEMAND_REQUEST_SEND_SUCCESS',
  DEMAND_REQUEST_SEND_ERROR = 'DEMAND_REQUEST_SEND_ERROR',
  DEMAND_CHANGE_USER_TYPE = 'DEMAND_CHANGE_USER_TYPE',
}
